import { Archive, RefreshCw, Sparkles, Trash2, Upload, UserPlus, Users } from "lucide-react";
import { SubBadge } from "@/components/admin/SectionShell";

export const AdminHeader = ({
  rows,
  regLimit,
  batchInput,
  setBatchInput,
  saveBatch,
  savingBatch,
  startNewBatch,
  startingBatch,
  archiveBatch,
  archiving,
  uploadPast,
  pastTotal,
  limitInput,
  setLimitInput,
  saveLimit,
  savingLimit,
  fewPctInput,
  setFewPctInput,
  saveFewPct,
  savingFewPct,
  selected,
  deleteSelected,
  onRefresh,
  onAddRegistration,
}) => (
  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
    <div>
      <p className="text-xs uppercase tracking-[0.3em] text-accent mb-2">Positive Life @SSVS</p>
      <h1 className="font-serif text-4xl"><SubBadge /> Registrations</h1>
      <p className="text-muted-foreground mt-1 flex items-center gap-2"><Users size={16} /> {rows.length} of {regLimit} seats filled</p>
    </div>
    <div className="flex flex-wrap gap-3">
      <div className="inline-flex items-center gap-2 rounded-full border border-border bg-white px-3 py-1.5" data-testid="batch-control">
        <span className="text-xs uppercase tracking-widest text-muted-foreground pl-1">Batch#</span>
        <input
          type="text" data-testid="batch-input" value={batchInput}
          onChange={(e) => setBatchInput(e.target.value)}
          className="w-24 bg-transparent border border-border rounded-lg px-2 py-1 text-sm text-center outline-none focus:border-accent"
        />
        <button data-testid="batch-save-btn" onClick={saveBatch} disabled={savingBatch} className="rounded-full bg-primary text-primary-foreground px-4 py-1.5 text-xs hover:-translate-y-0.5 transition-transform disabled:opacity-60">
          {savingBatch ? "…" : "Save"}
        </button>
      </div>
      <div className="inline-flex items-center gap-2 rounded-full border border-accent/40 bg-accent/5 px-3 py-1.5" data-testid="new-batch-control">
        <span className="text-xs uppercase tracking-widest text-muted-foreground pl-1" title="Participants saved from earlier batches">Past: {pastTotal}</span>
        <button data-testid="start-new-batch-btn" onClick={startNewBatch} disabled={startingBatch} className="inline-flex items-center gap-1.5 rounded-full bg-accent text-white px-4 py-1.5 text-xs hover:-translate-y-0.5 transition-transform disabled:opacity-60">
          <Sparkles size={12} /> {startingBatch ? "Starting…" : "Start New Batch"}
        </button>
        <button data-testid="archive-batch-btn" onClick={archiveBatch} disabled={archiving} title="Copy all current registrations into Past Batch (list stays, Batch# unchanged)" className="inline-flex items-center gap-1.5 rounded-full border border-primary text-primary px-4 py-1.5 text-xs hover:bg-primary hover:text-white transition-colors disabled:opacity-60">
          <Archive size={12} /> {archiving ? "Archiving…" : "Archive"}
        </button>
        <label data-testid="upload-past-label" className="inline-flex items-center gap-1.5 rounded-full border border-border bg-white px-4 py-1.5 text-xs cursor-pointer hover:bg-muted transition-colors" title="Upload past participants (.csv or .xlsx with Name, Mobile, Email, Profession, Place, Batch columns)">
          <Upload size={12} /> Upload Past
          <input type="file" accept=".csv,.xlsx" className="hidden" data-testid="upload-past-input" onChange={uploadPast} />
        </label>
      </div>
      <div className="inline-flex items-center gap-2 rounded-full border border-border bg-white px-3 py-1.5" data-testid="limit-control">
        <span className="text-xs uppercase tracking-widest text-muted-foreground pl-1">Max seats</span>
        <input
          type="number" min="0" data-testid="limit-input" value={limitInput}
          onChange={(e) => setLimitInput(e.target.value)}
          className="w-16 bg-transparent border border-border rounded-lg px-2 py-1 text-sm text-center outline-none focus:border-accent"
        />
        <button data-testid="limit-save-btn" onClick={saveLimit} disabled={savingLimit} className="rounded-full bg-primary text-primary-foreground px-4 py-1.5 text-xs hover:-translate-y-0.5 transition-transform disabled:opacity-60">
          {savingLimit ? "…" : "Save"}
        </button>
      </div>
      <div className="inline-flex items-center gap-2 rounded-full border border-border bg-white px-3 py-1.5" data-testid="fewpct-control">
        <span className="text-xs uppercase tracking-widest text-muted-foreground pl-1">"Few seats" at</span>
        <input
          type="number" min="1" max="100" data-testid="fewpct-input" value={fewPctInput}
          onChange={(e) => setFewPctInput(e.target.value)}
          className="w-16 bg-transparent border border-border rounded-lg px-2 py-1 text-sm text-center outline-none focus:border-accent"
        />
        <span className="text-xs text-muted-foreground">%</span>
        <button data-testid="fewpct-save-btn" onClick={saveFewPct} disabled={savingFewPct} className="rounded-full bg-primary text-primary-foreground px-4 py-1.5 text-xs hover:-translate-y-0.5 transition-transform disabled:opacity-60">
          {savingFewPct ? "…" : "Save"}
        </button>
      </div>
      {selected.length > 0 && (
        <button data-testid="delete-selected-btn" onClick={deleteSelected} className="inline-flex items-center gap-2 rounded-full border border-destructive text-destructive px-5 py-2.5 text-sm hover:bg-destructive hover:text-white transition-colors">
          <Trash2 size={16} /> Delete Selected ({selected.length})
        </button>
      )}
      <button data-testid="admin-refresh-btn" onClick={onRefresh} className="inline-flex items-center gap-2 rounded-full border border-border px-5 py-2.5 text-sm hover:bg-white transition-colors">
        <RefreshCw size={16} /> Refresh
      </button>
      <button data-testid="admin-add-reg-btn" onClick={onAddRegistration} className="inline-flex items-center gap-2 rounded-full border border-accent text-accent px-5 py-2.5 text-sm hover:bg-accent hover:text-white transition-colors">
        <UserPlus size={16} /> Add Registration
      </button>
    </div>
  </div>
);
